import { uploadFile as uploadFileToGcs } from '../../../shared/api/uploadFile';

// Mismas listas de extensiones que `uploadTaskFile()` (ComponentTaskHoy.jsx) -- se mantiene
// esa función intacta para el editor de descripción de tarea, que la sigue usando.
const RENDERABLE_IMAGE_EXT = ['png', 'gif', 'webp', 'svg', 'avif', 'bmp', 'jpg', 'jpeg'];
const RENDERABLE_VIDEO_EXT = ['mp4', 'webm', 'mov', 'ogg', 'quicktime'];

// Inserta vía comandos de TipTap, no `document.execCommand('insertHTML', ...)` -- ProseMirror
// gestiona su propio DOM por transacciones, mutar el DOM del editor por fuera de su API
// (como sí hace `uploadTaskFile()`) puede desincronizar su estado interno.
export function insertVideoEmbed(editor, url) {
    if (!editor) return;
    editor.chain().focus().insertContent([
        { type: 'taskCommentVideo', attrs: { src: url } },
        { type: 'text', text: ' ' },
    ]).run();
}

export async function uploadAndInsertFile(editor, file, { userId, onProgress } = {}) {
    if (!file || !editor) return null;
    const ext = file.name.split('.').pop()?.toLowerCase() || '';

    try {
        const url = await uploadFileToGcs(file, 'task_attachment', {
            extraFields: userId ? { userId } : {},
            onProgress,
        });

        if (RENDERABLE_IMAGE_EXT.includes(ext)) {
            editor.chain().focus().insertContent([
                { type: 'taskCommentImage', attrs: { src: url, alt: file.name } },
                { type: 'text', text: ' ' },
            ]).run();
        } else if (RENDERABLE_VIDEO_EXT.includes(ext)) {
            insertVideoEmbed(editor, url);
        } else {
            editor.chain().focus().insertContent([
                { type: 'taskCommentFile', attrs: { href: url, fileName: file.name } },
                { type: 'text', text: ' ' },
            ]).run();
        }
        return { success: true, url };
    } catch (e) {
        console.error('Task comment file upload error', e);
        return null;
    } finally {
        onProgress?.(0);
    }
}
